import { SetResult } from 'reducers/CommentHistory/CommentContexts';
import { actions } from 'reducers/CommentHistory/Snippets';
import { SnippetsClient } from 'sagas/Clients/SnippetsClient';
import { commentToSnippetSelector } from 'selectors/CommentHistory/Snippets';
import { ApiGetter } from 'sagas/Clients/ApiGetter';
import {
  call,
  put,
  select,
  spawn,
  SelectEffect,
  ForkEffect,
} from 'redux-saga/effects';
import { CommentToSnippet } from 'reducers/CommentHistory/Snippets';

export function* fetchSnippets({
  data,
}: SetResult): Generator<SelectEffect | ForkEffect, void, CommentToSnippet> {
  const commentToSnippet = (yield select(
    commentToSnippetSelector
  )) as CommentToSnippet;

  for (let i = 0; i < data.length; i++) {
    const { comment } = data[i];
    const snippet = commentToSnippet[comment.uuid];

    if (comment.type !== 'inline' || snippet !== undefined) {
      continue;
    }

    yield spawn(getSnippet, comment.uuid);
  }
}

export const snippetsClient = new SnippetsClient(new ApiGetter());

export function* getSnippet(uuid: string) {
  const { data, error } = yield call(
    [snippetsClient, snippetsClient.retrieveAsync],
    {
      commentUUID: uuid,
    }
  );

  if (error || data === undefined) {
    yield put(
      actions.insertCommentSnippet({ commentUUID: uuid, snippet: null })
    );
    return;
  }

  yield put(actions.insertCommentSnippet({ commentUUID: uuid, snippet: data }));
}
